'use client'

import { useBreakpoint } from '@/utils/responsive'
import { Box, Tab, Tabs } from '@mui/material'
import { useParams, useRouter } from 'next/navigation'
import { useState } from 'react'

const TeamTabs = ({ tabs = [] }) => {
  // get isPast query
  const isSm = useBreakpoint('sm')
  const router = useRouter()
  const category = useParams().category
  const [value, setValue] = useState(category || tabs[0].term_id)

  const handleChange = (event, newValue) => {
    setValue(newValue)
    router.push(`/team/${newValue}`)
  }

  return (
    <Box
      className="-full-width"
      sx={{ borderBottom: 1, borderColor: 'rgba(5,174,239,.15)' }}
    >
      <Tabs
        value={value}
        variant={isSm ? 'standard' : 'scrollable'}
        onChange={handleChange}
        scrollButtons={isSm ? 'auto' : true}
        allowScrollButtonsMobile
        aria-label="scrollable auto tabs"
        className="tw:w-full"
        centered={isSm}
      >
        {tabs.map((tab, idx) => (
          <Tab
            sx={{
              padding: isSm ? '0 44px' : '0 16px',
            }}
            key={tab.term_id || idx}
            value={tab.term_id}
            label={
              <span
                dangerouslySetInnerHTML={{
                  __html: tab.name || '',
                }}
              />
            }
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default TeamTabs
